import { css } from '@emotion/css';
import { NoResultsFoundIcon } from '../assets/icons';
import { Colors } from '../styles/colors';
import { p1Style } from '../styles/text';

export const NoResultsFound = (): JSX.Element => {
  return (
    <div className={containerStyle}>
      <NoResultsFoundIcon className={imageStyle} />
      <div className={textStyle}>No results found</div>
    </div>
  );
};

const textStyle = css`
  ${p1Style}
  color: ${Colors.TEXT_SECONDARY};
  padding-top: 1.5rem;
`;

const imageStyle = css`
  align-self: center;
`;

const containerStyle = css`
  display: flex;
  flex-direction: column;
  text-align: center;
  align-self: center;
  justify-self: center;
  flex: 1 1 auto;
  justify-content: center;
  padding: 2rem 0;
`;
